import { render, staticRenderFns } from "./Sect.vue?vue&type=template&id=a539b238&scoped=true&"
import script from "./Sect.vue?vue&type=script&lang=js&"
export * from "./Sect.vue?vue&type=script&lang=js&"
import style0 from "./Sect.vue?vue&type=style&index=0&id=a539b238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a539b238",
  null
  
)

export default component.exports